import { createFeatureSelector, createSelector } from '@ngrx/store';
import { LoadStatus } from '@capital-access/common/utils';
import { ACCOUNT_USERS_FEATURE_KEY, AccountUsersState } from './account-users.state';

export const getAccountUsersState = createFeatureSelector<AccountUsersState>(ACCOUNT_USERS_FEATURE_KEY);

export const getAccountUsers = createSelector(getAccountUsersState, state => state.users);

export const getAccountUsersLoadStatus = createSelector(getAccountUsersState, state => state.loadStatus);
export const getAccountUsersLoading = createSelector(
  getAccountUsersLoadStatus,
  status => status === LoadStatus.Loading
);

export const getAccountUsersLoaded = createSelector(getAccountUsersLoadStatus, status => status === LoadStatus.Loaded);

export const getAccountUsersFailed = createSelector(getAccountUsersLoadStatus, status => status === LoadStatus.Failed);
